import Notification from './Notification';
export default Notification;


//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/www/alipay-cd/project/antd-pro/antd-pro/scaffold/node_modules/_rc-notification@3.0.0@rc-notification/es/index.js
// module id = null
// module chunks = 